<script>
import { jwtDecode } from '@/helpers/jwt'
import store from '@/store'
import { InboxStatus } from '@/enums/InboxStatus'

export default {
  props: {
    item: { type: Object }
  },
  data: () => ({
    statuses: []
  }),
  computed: {
    userId() {
      let tokenDecoded = jwtDecode(store.getters.jwt)
      return tokenDecoded.sub !== '' ? tokenDecoded.sub : ''
    },
    styleButtonLeft() {
      const primary =
        this.$vuetify.theme.themes.light.primary || 'rgba(0, 44, 56, 0.9)'
      return {
        background: `${primary} !important`,
        borderRadius: '5px 0 0 5px',
        width: '80%'
      }
    }
  },
  created: function () {
    this.initializeStatusesList()
  },
  methods: {
    canEdit(item) {
      if (item?.actions) {
        return item?.actions?.canEdit
      }
      return true
    },
    initializeStatusesList() {
      this.statuses = []
      let inboxStatuses = Object.keys(InboxStatus)
      inboxStatuses.forEach((key, index) => {
        key === 'Open' &&
          this.statuses.push({
            title: this.$t('global.open'),
            id: index
          })
        key === 'Processing' &&
          this.statuses.push({
            title: this.$t('global.processing'),
            id: index
          })
        key === 'Closed' &&
          this.statuses.push({
            title: this.$t('global.closed'),
            id: index
          })
      })
    },
    updateStatus(item, status) {
      this.$inboxService
        .setDocumentStatus(item.id, status.id)
        .then(response => {
          this.$notify(
            this.$t('component.inbox.document.status.success', {
              document_id: item.workItemId,
              status: status.title
            }),
            { type: 'success' }
          )
          this.$emit('item-updated', response.data)
        })
        .catch(error => {
          console.error('Assignment Error: ', error)
          this.$notify(
            this.$t('component.inbox.document.status.error', {
              document_id: item.workItemId
            }),
            { type: 'error' }
          )
        })
    },
    finishItem(item) {
      this.updateStatus(item, {
        title: this.$t('global.closed'),
        id: 3
      })
    },
    assignItemToMe(item) {
      this.$inboxService
        .assignDocumentToMe(item.id)
        .then(() => {
          this.updateStatus(item, {
            title: this.$t('global.processing'),
            id: 2
          })
        })
        .catch(error => {
          console.error('Assignment Error: ', error)
        })
    }
  }
}
</script>
<template>
  <div class="inbox-button-container">
    <v-tooltip v-if="item.inboxStatus == 3" bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="button-left"
          disabled
          small
          v-bind="attrs"
          v-on="on"
        >
          {{ $t('global.closed') }}
        </v-btn>
      </template>
      <span>{{ $t('global.editation.already.done') }}</span>
    </v-tooltip>
    <v-tooltip
      v-if="item.userId && item.userId == userId && item.inboxStatus == 2"
      bottom
    >
      <template #activator="{ on, attrs }">
        <v-btn
          :dark="canEdit(item)"
          color="primary"
          class="button-left"
          :style="styleButtonLeft"
          small
          :disabled="!canEdit(item)"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="finishItem(item)"
        >
          {{ $t('button.finish') }}
        </v-btn>
      </template>
      <span>
        {{ $t('component.inbox.document.assigned.to.you') }}
      </span>
    </v-tooltip>
    <v-tooltip
      v-if="
        (item.userId && item.userId != userId && item.inboxStatus == 2) ||
        (!item.userId && item.inboxStatus == 2)
      "
      bottom
    >
      <template #activator="{ on, attrs }">
        <v-btn
          :dark="canEdit(item)"
          small
          color="primary"
          class="button-left"
          :style="styleButtonLeft"
          :disabled="!canEdit(item)"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="assignItemToMe(item)"
        >
          {{ $t('button.take.over') }}
        </v-btn>
      </template>
      <span>
        {{ $t('component.inbox.document.not.assigned.to.you') }}
      </span>
    </v-tooltip>
    <v-tooltip v-if="item.inboxStatus == 1 || 0" bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          :dark="canEdit(item)"
          small
          color="primary"
          class="button-left"
          :style="styleButtonLeft"
          :disabled="!canEdit(item)"
          v-bind="attrs"
          v-on="on"
          @click.stop.prevent="assignItemToMe(item)"
        >
          {{ $t('button.edit') }}
        </v-btn>
      </template>
      <span>{{ $t('component.inbox.start.editation') }}</span>
    </v-tooltip>
    <v-btn
      :id="'item-status-activator-' + item.id"
      color="primary"
      class="button-right"
      :disabled="!canEdit(item)"
      small
    >
      <v-icon dark>mdi-chevron-down</v-icon>
    </v-btn>
    <v-menu :activator="'#item-status-activator-' + item.id">
      <v-list>
        <v-list-item
          v-for="(status, index) in statuses.filter(
            s => s.id !== item.inboxStatus
          )"
          :key="index"
          :value="index"
          class="inbox-dropdown-list-item"
        >
          <v-list-item-title
            @click="
              status.id == 2 ? assignItemToMe(item) : updateStatus(item, status)
            "
          >
            {{ status.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<style lang="scss" scoped>
.button-left,
.button-right {
  white-space: nowrap;
}
.button-left {
  border-radius: 5px 0 0 5px;
  background: rgba(0, 44, 56, 0.9) !important;
  width: 80%;
}
.button-right {
  border-radius: 0 5px 5px 0;
  width: 20%;
}
</style>
